<div class="bg-white dark:bg-[rgb(17,17,17)] text-gray-900 dark:text-gray-100 rounded-xl overflow-hidden shadow-[4px_4px_15px_rgba(0,0,0,0.1)] w-full flex flex-col h-40 md:h-[130px]">
    <!-- Header -->
    <div class="px-4 pb-0 pt-3">
        <div class="flex items-center justify-between">
            <h5 class="text-lg font-semibold m-0 text-gray-800 dark:text-gray-100">
                {{ titulo }}
            </h5>

            <!-- Botón de info -->
            <p-button
                [text]="true"
                severity="secondary"
                size="small"
                icon="pi pi-info-circle"
                class="ml-2"
                (onClick)="isMobile ? info.toggle($event) : null"
                [pTooltip]="!isMobile ? (headerTooltip ?? defaultHeaderTooltip) : undefined"
                [tooltipPosition]="headerTooltipPosition"
                [tooltipStyleClass]="headerTooltipStyleClass"
            >
            </p-button>

            <!-- Popover SOLO en móvil -->
            <p-popover #info class="gv-tooltip">
                <ng-container *ngTemplateOutlet="headerTooltip ?? defaultHeaderTooltip"></ng-container>
            </p-popover>

            <!-- Tooltip por defecto -->
            <ng-template #defaultHeaderTooltip>
                <div class="flex flex-col items-center justify-center w-full max-w-[360px] px-3 text-white">
                    <i class="pi pi-info-circle text-2xl mb-2"></i>
                    <span class="text-sm text-center leading-snug"> Sin información adicional </span>
                </div>
            </ng-template>
        </div>
    </div>

    <!-- Lista -->
    <div class="flex-1 px-4 pb-3 overflow-y-auto space-y-2 pr-2">
        @for (rec of recordatorios; track rec) {
            <div class="rec--tone text-xs rounded p-2" [style.backgroundColor]="rec.color || null" [style.color]="rec.textoColor || null">
                <div class="flex justify-between items-center gap-3">
                    <!-- IZQ: título -->
                    <span class="truncate">{{ rec.titulo }}</span>

                    <!-- DER: horario + ojo si hay url -->
                    <div class="flex items-center gap-2 shrink-0">
                        <span class="opacity-80">{{ rec.horario }}</span>

                        @if (rec.url) {
                            <a [href]="rec.url" [attr.target]="isMobile ? null : '_blank'" [attr.rel]="isMobile ? null : 'noopener noreferrer'" class="rec--icon inline-flex items-center justify-center" title="Ver detalle">
                                <i class="pi pi-eye"></i>
                            </a>
                        }
                    </div>
                </div>
            </div>
        } @empty {
            <div class="flex flex-col items-center justify-center h-full gap-1 py-2 text-center">
                <i [class]="emptyIcon + ' text-green-400 text-xl'"></i>
                <span class="text-xs text-gray-400 dark:text-gray-500 leading-snug">{{ emptyMessage }}</span>
            </div>
        }
    </div>
</div>
